import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RenderIfChildExists from "@sprout/client-components/dist/RenderIfChildExists";
import { Link } from "react-router-dom";
import { UserType } from "sprout-graphql";
import { Button } from "sprout-ui-dom";
import { EditOutlined, SettingsOutlined } from "sprout-ui-icons";
import { Flex, Text } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled from "styled-components";
import useProfileAuthorization from "./useProfileAuthorization";
const ProfilePageUserHeaderTopButtonsWrapper = styled(Flex)`
  > * + * {
    margin-left: 8px;
  }

  margin-bottom: -40px;

  ${media.down("medium")} {
    display: none;
  }
`;
const ProfilePageUserHeaderTopButtons = (props)=>{
    const { user  } = props;
    const { type , username  } = user;
    const authorization = useProfileAuthorization(user);
    return /*#__PURE__*/ _jsxs(RenderIfChildExists, {
        component: /*#__PURE__*/ _jsx(ProfilePageUserHeaderTopButtonsWrapper, {
            alignItems: "center",
            justifyContent: "flex-end",
            height: "64px",
            px: 2
        }),
        children: [
            authorization.editProfile && /*#__PURE__*/ _jsxs(Button, {
                variant: "purple",
                as: Link,
                to: `/${type === UserType.Team ? username : "my"}/edit-profile`,
                children: [
                    /*#__PURE__*/ _jsx(EditOutlined, {}),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        ml: 0,
                        children: "Edit"
                    })
                ]
            }),
            authorization.viewSettings && /*#__PURE__*/ _jsxs(Button, {
                variant: "purple",
                as: Link,
                to: `/${username}/settings`,
                children: [
                    /*#__PURE__*/ _jsx(SettingsOutlined, {}),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        ml: 0,
                        children: "Settings"
                    })
                ]
            })
        ]
    });
};
export default ProfilePageUserHeaderTopButtons;
